<template>
  <wa-page>
    <wa-page-header
      slot="header"
      key="header"
    />
    <div
      slot="content"
      class="app-content"
    >
      <section
        class="padding-top-5xl"
        style="overflow: hidden; background-color: var(--white)"
      >
        <div class="container">
          <hero />

          <nav class="tabs">
            <site-link
              :to="{ name: 'leaderboard.new' }"
              class="tab"
              active-class="active"
            >
              <font-awesome-icon :icon="$v6.solid.faIcons" />
              <span class="text-capitalize display-none tablet:display-inline-block tablet:margin-left-2xs">
                <span class="sr-only">Top Requested</span>
                Icons
              </span>
            </site-link>

            <site-link
              :to="{ name: 'leaderboard.brands' }"
              class="tab"
              active-class="active"
            >
              <font-awesome-icon :icon="$v6.brands.faFontAwesome" />
              <span class="text-capitalize display-none tablet:display-inline-block tablet:margin-left-2xs">
                <span class="sr-only">Top Requested</span>
                Brands
              </span>
            </site-link>

            <site-link
              :to="{ name: 'leaderboard.inprogress' }"
              class="tab"
              active-class="active"
            >
              <font-awesome-icon :icon="$v6.solid.faCompassDrafting" />
              <span class="text-capitalize display-none tablet:display-inline-block tablet:margin-left-2xs">In Progress</span>
            </site-link>

            <site-link
              :to="{ name: 'leaderboard.released' }"
              class="tab"
              active-class="active"
            >
              <font-awesome-icon :icon="$v6.solid.faSparkles" />
              <span class="text-capitalize display-none tablet:display-inline-block tablet:margin-left-2xs">
                <span class="sr-only">Top Requested Icons that Have Been</span>
                Released
              </span>
            </site-link>
          </nav>
        </div>
      </section>

      <div class="container padding-top-4xl padding-bottom-7xl">
        <div
          class="margin-bottom-6xl"
          style="--table-striped-row-background: var(--white); --table-cell-border-color: var(--white)"
        >
          <router-view />
        </div>

        <sock />
      </div>
    </div>

    <wa-page-footer slot="footer" />
  </wa-page>
</template>

<script>
  import Hero from './sections/Hero'
  import Sock from './sections/Sock'

  export default {
    name: 'IconRequestsView',

    components: {
      Hero,
      Sock
    }
  }
</script>
